import { AppPermissions } from '../constants/Permissions';

export default {
  dashboard: {
    category: 'dashboard',
    key: 'dashboard.home',
    title: 'Dashboard',
    url: '/',
    activeWhen: ['/dashboard'],
    icon: 'HomeOutlined',
    public: true,
    subMenus: [],
  },
  visits: {
    category: 'visits',
    key: 'visits',
    title: 'Visits',
    url: '/visits',
    icon: 'DirectionsWalkOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.Visit.Read,
  },
  stockDetails: {
    category: 'stockDetails',
    key: 'stockDetails',
    title: 'Stock Details',
    url: '/stockDetails',
    icon: 'InventoryOutlined',
    subMenus: [],
    // guardedPermission: AppPermissions.StockDetails.Read,
  },
  taskQueue: {
    category: 'tasksQueue',
    key: 'tasksQueue',
    title: 'Tasks Queue',
    url: '/tasksqueue',
    icon: 'ChecklistOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.TasksQueue.Read,
  },
  devices: {
    category: 'devices',
    key: 'devices',
    title: 'Devices',
    url: '/devices',
    icon: 'OnDeviceTrainingOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.Device.Read,
  },
  sightings: {
    category: 'sightings',
    key: 'sightings',
    title: 'Sightings',
    url: '/sightings',
    icon: 'RemoveRedEyeOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.SightingLatest.Read,
  },
  readers: {
    category: 'readers',
    key: 'readers',
    title: 'Readers',
    url: '/readers',
    icon: 'FingerprintOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.Reader.Read,
  },
  equipment: {
    category: 'equipments',
    key: 'equipments',
    title: 'Equipment',
    url: '/equipment',
    icon: 'HomeRepairServiceOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.Equipment.Read,
  },
  geofence: {
    category: 'geofences',
    key: 'geofences',
    title: 'Geofences',
    url: '/geofences',
    icon: 'AlbumOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.Geofence.Read,
  },
  facilities: {
    category: 'facilities',
    key: 'facilities',
    title: 'Facilities',
    url: '/facilities',
    icon: 'BallotOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.Facility.Read,
  },
  scansessions: {
    category: 'scansessions',
    key: 'scansessions',
    title: 'Scan Sessions',
    url: '/scansessions',
    icon: 'DocumentScannerOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.ScanSession.Read,
  },
  pairingHistory: {
    category: 'pairinghistory',
    key: 'pairinghistory',
    title: 'Pairing History',
    url: '/pairinghistory',
    icon: 'Timeline',
    subMenus: [],
    guardedPermission: AppPermissions.Pairing.Read,
  },
  collections: {
    category: 'collections',
    key: 'collections',
    title: 'Collections',
    url: '/collections',
    icon: 'CollectionsBookmarkOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.Collections.Read,
  },
  transfers: {
    category: 'transfers',
    key: 'transfers',
    title: 'Transfers',
    url: '/transfers',
    icon: 'FlightTakeoffOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.LucTransfer.Read,
  },
  appReleases: {
    category: 'appReleases',
    key: 'appReleases',
    title: 'App Releases',
    url: '/app-releases',
    icon: 'SystemUpdateOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.Apk.Read,
  },
  downloads: {
    category: 'downloads',
    key: 'downloads',
    title: 'Downloads',
    url: '/downloads',
    icon: 'FileDownloadOutlined',
    subMenus: [],
    guardedPermission: AppPermissions.Export.Read,
  },
  // monitoring: {
  //   category: 'monitoring',
  //   key: 'monitoring',
  //   title: 'Monitoring',
  //   url: '/monitoring',
  //   icon: 'ScreenSearchDesktopOutlined',
  //   subMenus: [],
  // },
  // report: {
  //   category: 'report',
  //   key: 'report',
  //   title: 'Reports',
  //   icon: 'InsertChartOutlinedTwoTone',
  //   subMenus: [
  //     {
  //       key: 'report.readers',
  //       title: 'Readers',
  //       url: '/report/readers',
  //       icon: '',
  //       subMenus: [],
  //     },
  //     {
  //       key: 'report.inventory',
  //       title: 'Inventory report',
  //       url: '/report/inventory',
  //       icon: '',
  //       subMenus: [],
  //     },
  //   ],
  // },
  administration: {
    key: 'admin',
    category: 'administration',
    title: 'Administration',
    icon: 'AdminPanelSettingsOutlined',
    subMenus: [
      {
        category: 'administration',
        key: 'settings',
        title: 'Settings',
        url: '/settings',
        icon: 'TuneOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.Setting.Read,
      },
      {
        category: 'administration',
        key: 'user-guide',
        title: 'User Guide',
        url: '/user-guide',
        icon: 'ClassOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.UserGuide.Manage,
      },
      {
        category: 'administration',
        key: 'users',
        title: 'Users',
        url: '/users',
        icon: 'AccountBoxOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.User.Manage,
      },
      {
        category: 'administration',
        key: 'contracts',
        title: 'Contracts',
        url: '/contracts',
        icon: 'HandshakeOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.Contract.Read,
      },
      {
        category: 'administration',
        key: 'companies',
        title: 'Companies',
        url: '/companies',
        icon: 'BusinessOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.Company.Read,
      },
      {
        category: 'administration',
        key: 'admission',
        title: 'Admission',
        url: '/admission',
        icon: 'PersonAddOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.User.Manage,
      },
      {
        category: 'administration',
        key: 'policies',
        title: 'Policies',
        url: '/policies',
        icon: 'PolicyOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.System.Admin,
      },
      {
        category: 'administration',
        key: 'role',
        title: 'Roles',
        url: '/roles',
        icon: 'WorkspacePremiumOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.System.Admin,
      },
      {
        category: 'administration',
        key: 'scopetemplates',
        title: 'Scopes',
        url: '/scopetemplates',
        icon: 'AccountTreeOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.System.Admin,
      },
      {
        category: 'administration',
        key: 'super-sentinel-activation',
        title: 'Super Sentinel Activation',
        url: '/super-sentinel-activation',
        icon: 'SecurityOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.SuperSentinel.Manage,
      },
      {
        category: 'administration',
        key: 'manageInventory',
        title: 'Inventory',
        url: '/manageInventory',
        icon: 'Inventory2Outlined',
        subMenus: [],
        guardedPermission: AppPermissions.Device.Import,
      },
      {
        category: 'administration',
        key: 'languages',
        title: 'Languages',
        url: '/languages',
        icon: 'GTranslateOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.Language.Manage,
      },
      {
        category: 'administration',
        key: 'templates',
        title: 'Templates',
        url: '/templates',
        icon: 'MarkAsUnreadOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.Language.Manage,
      },
      {
        category: 'labels',
        key: 'labels',
        title: 'Labels',
        url: '/labels',
        icon: 'PhotoAlbumOutlined',
        subMenus: [],
        guardedPermission: AppPermissions.Label.Edit,
      },
    ],
  },
};
